export default __webpack_public_path__ + "static/scratch-container-rectangle-1-6ebcb6b74566bf77ac36e9de6d247fc4.svg";